import React, { useEffect, useState } from 'react';
import styles from './index.module.scss';

import { useParams } from 'react-router-dom';
import { getProductDetails } from '@/tpss/apis/api';
import {
  IProduct,
  IProductPackageNode,
  IProductVersion,
  PackageNodeTypeBaseline,
  PackageNodeTypePatch,
  PatchPageDetails,
  PatchPageList
} from '@/tpss/types';
import ProductDetailsBanner from './components/ProductDetailsBanner';
import ProductDetailContext from './context/ProductDetailContext';
import ProductVersionDetail from './components/ProductVersionDetail';
import { numToStr } from '@/tpss/utils/utils';

interface ProductVersionDetailsProps {}
const ProductVersionDetails: React.FC<ProductVersionDetailsProps> = () => {
  const { id } = useParams();
  const { pid } = useParams();
  const [activeVersionId, setActiveVersionId] = useState('');
  const [activeProductCode, setAactiveProductCode] = useState('cvm');
  const [targetPackageData, setTargetPackageData] = useState<IProductPackageNode>(
    {} as any
  );
  const [selectedBaselinePackageData, setSelectedBaselinePackageData] =
    useState<IProductPackageNode>({} as any);
  const [currentPatchList, setCurrentPatchList] = useState<any[]>([]);
  const [productDetail, setProductDetail] = useState<IProduct>({} as any);
  const [softwareDownloadData, setSoftwareDownloadData] = useState<any>([]);
  const [materialDownloadData, setMaterialDownloadData] = useState<any>([]);
  const [toolDownloadData, setToolDownloadData] = useState<any>([]);
  const [currentSoftwareType, setCurrentSoftwareType] = useState<string>(
    PackageNodeTypeBaseline
  );
  const [currentProductVersion, setCurrentProductVersion] =
    useState<IProductVersion>({} as any);
  const [currentBaseline, setCurrentBaseline] = useState<string>('');
  const [currentPatch, setCurrentPatch] = useState<string>('');
  const [patchPage, setPatchPage] = useState<string>(PatchPageList);

  const getProductDetailData = async () => {
    // console.log(id, pid);
    if (id) {
      // console.log('start render');
      const productDetails: any = await getProductDetails(id);
      // 全量数据
      setProductDetail(productDetails.Data);
      displayNode(pid, productDetails.Data);
      // setActiveVersionId(productDetails.Data.Versions[0].ID);
      // setCurrentProductVersion(productDetails.Data.Versions[0]);
      // console.log('start choose baseline from use effect', productDetails.Data);
      // chooseBaselinePackageNode(
      //   getFirstPackageNode(
      //     productDetails.Data.Versions[0].ID.toString(),
      //     productDetails.Data
      //   )
      // );
    }
  };
  function displayNode(pid, productDetail): void {
    // console.log('displayNode');
    if (pid !== '0' && pid !== undefined) {
      // console.log('try');
      const { version, baselineNode, patchNode } = getPackageNodeByPid(
        pid,
        productDetail
      );
      // console.log('finish');
      if (version !== null && baselineNode != null) {
        // console.log('render specific');
        doRenderPageForNode(version, baselineNode, patchNode);
        return;
      }
    }
    // console.log('render default');
    doRenderPageForNode(
      productDetail.Versions[0],
      getFirstPackageNode(productDetail.Versions[0].ID.toString(), productDetail),
      null
    );
  }
  function getPackageNodeByPid(pid, productDetail) {
    // console.log('getPackageNodeByPid', pid, productDetail);
    let currentVersion: IProductVersion = {} as IProductVersion;
    for (let i = 0; i < productDetail.Versions.length; i++) {
      // console.log(i);
      currentVersion = productDetail.Versions[i];
      for (let j = 0; j < productDetail.Versions[i].Nodes.length; j++) {
        // console.log(j);
        if (numToStr(productDetail.Versions[i].Nodes[j].ID) === pid) {
          // console.log('return baseline');
          return {
            version: currentVersion,
            baselineNode: productDetail.Versions[i].Nodes[j],
            patchNode: null
          };
        }
        // console.log('next', j);
        let currentBaselineNode: IProductPackageNode =
          productDetail.Versions[i].Nodes[j];
        // console.log('currentNode', currentBaselineNode);
        if (currentBaselineNode.Nodes) {
          for (let k = 0; k < currentBaselineNode.Nodes.length; k++) {
            // console.log('patch:', currentBaselineNode.Nodes[k].ID);
            if (numToStr(currentBaselineNode.Nodes[k].ID) === pid) {
              // console.log('return patch');
              return {
                version: currentVersion,
                baselineNode: currentBaselineNode,
                patchNode: currentBaselineNode.Nodes[k]
              };
            }
          }
        }
      }
    }
    // console.log('return null');
    return { version: null, baselineNode: null, patchNode: null };
  }
  function doRenderPageForNode(version, baselineNode, patchNode): void {
    // setActiveVersionId(version.ID);
    setCurrentProductVersion(version);
    if (baselineNode !== null) {
      if (baselineNode.ProductPackageNodeType === PackageNodeTypeBaseline) {
        chooseBaselinePackageNode(baselineNode);
      }
    }
    if (patchNode !== null) {
      if (patchNode.ProductPackageNodeType === PackageNodeTypePatch) {
        choosePatchPackageNode(patchNode);
      }
    }
  }

  const onVersionChange = ({ id, name }) => {
    setActiveVersionId(id);
    chooseBaselinePackageNode(getFirstPackageNode(id, productDetail));
    setCurrentProductVersion(getSelectedVersion(id, productDetail));
  };

  function getSelectedVersion(id, productDetails) {
    if (!productDetail.Versions) {
      return null;
    }
    for (let i = 0; i < productDetails.Versions.length; i++) {
      if (numToStr(productDetails.Versions[i].ID) === id) {
        return productDetails.Versions[i];
      }
    }
    return null;
  }
  const onProductCodeChange = ({ id, name }) => {
    // setActiveVersionId(activeVersionId);
    setAactiveProductCode(id);
    chooseBaselinePackageNode(getFirstPackageNode(activeVersionId, productDetail));
    // console.log('onProductCode', id);
    // setVersionName(name);
  };

  function getFirstPackageNode(versionID, prorductData): IProductPackageNode {
    // console.log('getFirstPackageNode', versionID, prorductData);
    for (let i = 0; i < prorductData.Versions.length; i++) {
      if (numToStr(prorductData.Versions[i].ID) === versionID) {
        // console.log('find');
        return prorductData.Versions[i].Nodes[0];
      }
    }
    return {} as IProductPackageNode;
  }

  function updateCurrentPatchList(baselienNode: IProductPackageNode) {
    const patchList: IProductPackageNode[] = [];
    if (baselienNode && baselienNode.Nodes) {
      for (let i = 0; i < baselienNode.Nodes.length; i++) {
        patchList.push(baselienNode.Nodes[i]);
      }
    }
    setCurrentPatchList(patchList);
  }

  function chooseBaselinePackageNode(packageNode: IProductPackageNode) {
    // console.log('chooseBaselinePackageNode', packageNode);
    setTargetPackageData(packageNode);
    updateDownloadTable(packageNode);
    setCurrentBaseline(packageNode.ProductPackageNodeName);
    setSelectedBaselinePackageData(packageNode);
    updateCurrentPatchList(packageNode);
    setPatchPage(PatchPageList);
    // setCurrentSoftwareType
    // setCurrentSoftwareType(PackageNodeTypeBaseline);
  }

  function choosePatchPackageNode(packageNode: IProductPackageNode) {
    setTargetPackageData(packageNode);
    updateDownloadTable(packageNode);
    setCurrentPatch(packageNode.ProductPackageNodeName);
    setPatchPage(PatchPageDetails);
    setCurrentSoftwareType(PackageNodeTypePatch);
  }

  function updateDownloadTable(packageData) {
    const softwareDownloadData: any[] = [];
    const materialDownloadData: any[] = [];
    const toolDownloadData: any[] = [];
    if (packageData && packageData.Artifacts) {
      // console.log('packageData.Artifacts', packageData.Artifacts);
      for (let i = 0; i < packageData.Artifacts.length; i++) {
        const downloadItem = {
          filename: packageData.Artifacts[i].ArtifactName,
          description: packageData.Artifacts[i].ArtifactDescription,
          type: packageData.Artifacts[i].ArtifactType,
          size: packageData.Artifacts[i].SizeDisplay,
          md5: packageData.Artifacts[i].ArtifactChecksum,
          manipulate: '下载',
          url: packageData.Artifacts[i].DownloadURL
        };
        if (
          packageData.Artifacts[i].ArtifactType === '软件补丁包' ||
          packageData.Artifacts[i].ArtifactType === '软件安装包'
        ) {
          softwareDownloadData.push(downloadItem);
        } else if (packageData.Artifacts[i].ArtifactType === '工具') {
          toolDownloadData.push(downloadItem);
        } else {
          materialDownloadData.push(downloadItem);
        }
      }
    }
    setSoftwareDownloadData(softwareDownloadData);
    setMaterialDownloadData(materialDownloadData);
    setToolDownloadData(toolDownloadData);
  }

  useEffect(() => {
    window.scrollTo(0, 0);
    getProductDetailData();
  }, [id]);

  return (
    <ProductDetailContext.Provider
      value={{
        currentProductVersion,
        setCurrentProductVersion,
        targetPackageData,
        setTargetPackageData,
        selectedBaselinePackageData,
        setSelectedBaselinePackageData,
        softwareDownloadData,
        materialDownloadData,
        toolDownloadData,
        chooseBaselinePackageNode,
        choosePatchPackageNode,
        currentSoftwareType,
        setCurrentSoftwareType,
        patchPage,
        setPatchPage,
        currentPatchList,
        setCurrentPatchList,
        currentBaseline,
        setCurrentBaseline,
        currentPatch,
        setCurrentPatch
      }}
    >
      <div className={styles.productDetail}>
        <ProductDetailsBanner
          productVersionRaw={productDetail.Versions}
          productDetail={productDetail}
          activeVersionId={activeVersionId}
          activeProductCode={activeProductCode}
          onVersionChange={onVersionChange}
          onProductCodeChange={onProductCodeChange}
        />
        <ProductVersionDetail
          productVersionID={activeVersionId}
          productCode={activeProductCode}
          productVersions={productDetail.Versions}
        />
      </div>
    </ProductDetailContext.Provider>
  );
};

export default ProductVersionDetails;
